module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAZCAMAAACM5megAAAAPFBMVEUAAAABZWABZWABZWAAZWABZWACZ2ABaGAAaGACZWACZmAAZWABZWACZmABZGADZWABZmAAamABZmABZWBomvmEAAAAE3RSTlMA3++AYL9AIBCfcDDPj29grzDPehinswAAALZJREFUKM99kkkSwyAMBC2xeo2d/v9fUyliUgbLc9KhAc0Mw1VxVHR/DQ9ygADrE6IuD9kLo4UkmMsgRINZ6xueYDCB4zdl1GCEdI6KwezEuplYtqqdzTSWlZLerCTLvIcxpujADaZGioJJzAEQEUCMyjZ4T/m7lw/gDGT6b6Z3UAJfptNavCnCNR4lN0hEukNT59q3p7oEFo4u9bZ7xfwGVWjvomUWpm4f+jpVLrqJ2i9cJfXiDxBnCS9q7nQFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/euro/icon-user.png
// module id = e1c8
// module chunks = 0